import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"margin-left":"20px","display":"flex","align-items":"flex-end","flex-wrap":"wrap"} }
const _hoisted_2 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"3px","display":"block"} }, "开票日期", -1)
const _hoisted_4 = { style: {"width":"100%","display":"flex","align-items":"flex-end","flex-wrap":"wrap"} }
const _hoisted_5 = { style: {"margin-right":"15px"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"display":"block"} }, "票面金额", -1)
const _hoisted_7 = { style: {"position":"relative"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "发票号码", -1)

import { ref, computed } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseImage,
  BaseUpload,
  BaseIcon,
  BaseInputNumber,
  BaseDatePicker
} from 'xrk-components';
import { uploadApi } from '@data-source/common/apis';
import { MakeOutAnInvoiceParams } from '@V/invoice/src/data-source/types';
import { DeleteFilled } from '@element-plus/icons-vue';
import { useRecognition } from '@V/invoice/src/hooks';
import { StateType } from '@cTypes/order';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-detail-individual-dialog-form',
  props: /*#__PURE__*/_mergeModels({
    id: {},
    invoiceBusinessType: { default: 7 }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const props = __props;

const modelValue = _useModel<MakeOutAnInvoiceParams>(__props, "modelValue"); // 集合中只会有一个元素
const formRef = ref(null);
const disabled = ref(!!props.id);

const formRules = {
  // taskAt: [
  //   {
  //     required: true,
  //     trigger: 'change',
  //     message: '请选择结算月度'
  //   }
  // ],
  imgList: [
    {
      required: true,
      trigger: 'change',
      validator: (rule, v, callback) => {
        if (!v?.length) {
          return callback(new Error('请上传发票'));
        }
        if (v.some(item => !item.invoicePic)) {
          return callback(new Error('请重新上传发票'));
        }
        if (v.some(item => !item.invoiceAmount || !item.invoiceNo)) {
          return callback(new Error('请填写发票信息'));
        }
        if (v.some(item => !item.invoiceDate && isType7.value)) {
          return callback(new Error('请填写开票日期'));
        }
        callback();
      }
    }
  ],
  fileList: [
    {
      required: false,
      trigger: 'change',
      validator: (rule, v, callback) => {
        if (v.some(item => !item.url)) {
          return callback(new Error('请重新上传资料'));
        }
        callback();
      }
    }
  ]
};

const isType7 = computed(() => true); // 写死个体7

const onImgChange = async v => {
  const { response } = v;
  if (response && response.data.fileUrl) {
    const ocr = await useRecognition(response.data.fileUrl);
    modelValue.value.imgList.push({
      id: null,
      invoicePic: response.data.fileUrl,
      invoiceType: 1, // 写死，只有蓝票
      invoiceApplyId: props.id,
      remark: null,
      createAt: Date.now(),
      ...ocr
    });
  }
  formRef.value.validate('imgList');
};
const onImgRemove = index => {
  modelValue.value.imgList.splice(index, 1);
  formRef.value.validate('imgList');
};
const onFilePreview = v => {
  window.open(v.url);
};

__expose({
  validate: (...args: any) => formRef.value?.validate(...args)
});

return (_ctx: any,_cache: any) => {
  return (modelValue.value)
    ? (_openBlock(), _createBlock(_unref(BaseForm), {
        key: 0,
        ref_key: "formRef",
        ref: formRef,
        "label-position": "right",
        scrollToError: "",
        model: modelValue.value,
        rules: formRules
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseFormItem), {
            label: "发票照片",
            prop: "imgList"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (!disabled.value)
                  ? (_openBlock(), _createBlock(_unref(BaseUpload), {
                      key: 0,
                      style: {"margin-bottom":"20px"},
                      autoUpload: "",
                      btnText: "上传",
                      tipText: "只能上传jpg/png，且每份不超过50MB",
                      listType: null,
                      accept: ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'],
                      limit: 20,
                      limitSize: 50,
                      multiple: false,
                      showFileList: false,
                      "http-request": _unref(uploadApi),
                      onChange: onImgChange
                    }, null, 8, ["http-request"]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelValue.value.imgList, (img, imgIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: {"display":"flex","align-items":"flex-end","margin-bottom":"30px"},
                    key: img.invoicePic
                  }, [
                    _createVNode(_unref(BaseImage), {
                      style: {"width":"200px","height":"120px"},
                      src: img.invoicePic,
                      "preview-src-list": [img.invoicePic]
                    }, null, 8, ["src", "preview-src-list"]),
                    _createElementVNode("div", _hoisted_1, [
                      (isType7.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _hoisted_3,
                            _createVNode(_unref(BaseDatePicker), {
                              style: {"width":"240px"},
                              type: "date",
                              "validate-event": "",
                              disabled: disabled.value,
                              modelValue: img.invoiceDate,
                              "onUpdate:modelValue": ($event: any) => ((img.invoiceDate) = $event)
                            }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _hoisted_6,
                          _createVNode(_unref(BaseInputNumber), {
                            style: {"width":"240px","display":"block"},
                            placeholder: "请输入",
                            disabled: disabled.value,
                            controls: false,
                            precision: 2,
                            min: 0,
                            max: 999999999,
                            modelValue: img.invoiceAmount,
                            "onUpdate:modelValue": ($event: any) => ((img.invoiceAmount) = $event)
                          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createVNode(_unref(BaseInput), {
                            style: {"width":"240px"},
                            disabled: disabled.value,
                            modelValue: img.invoiceNo,
                            "onUpdate:modelValue": ($event: any) => ((img.invoiceNo) = $event)
                          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
                          (!disabled.value)
                            ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                                key: 0,
                                size: "18",
                                color: "#ED7067",
                                style: {"cursor":"pointer","position":"absolute","right":"-35px","bottom":"10px"},
                                onClick: ($event: any) => (onImgRemove(imgIndex))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(DeleteFilled))
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          (!disabled.value || modelValue.value.fileList?.length)
            ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                key: 0,
                label: "其他材料",
                prop: "fileList"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseUpload), {
                    style: {"margin-bottom":"20px"},
                    listType: "text",
                    autoUpload: "",
                    showFileList: "",
                    btnText: "添加文件",
                    tipText: 
          disabled.value ? '' : '只能上传png/jpg/jpeg/pdf/bmp文件，且每份不超过50MB'
        ,
                    accept: ['.jpg', '.jpeg', '.png', '.pdf', '.bmp'],
                    limit: disabled.value ? 1 : 10,
                    limitSize: 50,
                    multiple: false,
                    "http-request": _unref(uploadApi),
                    disabled: disabled.value,
                    uploadBtnProps: {
          limitOverHide: true
        },
                    fileList: modelValue.value.fileList,
                    "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.fileList) = $event)),
                    onPreview: onFilePreview
                  }, null, 8, ["tipText", "limit", "http-request", "disabled", "fileList"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model"]))
    : _createCommentVNode("", true)
}
}

})